/**
 * A régua de formatação das células das tabelas do Radar (transversal/at-82).
 *
 * Morava em `views/contac/radar/components/DetalheRecomendacaoModal.tsx` e era importada de lá
 * por três consumidores — inclusive pelo modal do Relacionamento, que vive em outra view e não
 * tem relação com o modal de detalhe do Financeiro. Trazer para o componente compartilhado
 * elimina o import cruzado entre views e deixa a régua num arquivo que se acha pelo nome.
 */

/** O tipo de coluna, na forma mínima que a formatação precisa conhecer. */
export interface ColunaFormatavel {
  tipo: string;
}

export function formatarCelula(
  valor: string | number | null | undefined,
  coluna: ColunaFormatavel,
): string {
  if (valor === null || valor === undefined || valor === '') return '-';

  if (coluna.tipo === 'moeda') {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
      Number(valor),
    );
  }

  if (coluna.tipo === 'numero') {
    return new Intl.NumberFormat('pt-BR').format(Number(valor));
  }

  if (coluna.tipo === 'percentual') {
    return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(Number(valor))}%`;
  }

  return String(valor);
}
